import React, { useCallback, useEffect, useRef, useState } from "react";
import Utils from "Common/Utils";

type ActionProps = {
    onOpenImportModal: () => void;
    onOpenValidateModal: () => void;
    onExport: () => void;
    disabled: boolean;
    openAttributeMenu: () => void;
}

export const Actions = ({ onOpenImportModal, onOpenValidateModal, onExport, disabled, openAttributeMenu }: ActionProps) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined)

    const ref = useRef<HTMLDivElement>(null);

    const handleClickOutside = useCallback(
        (e: MouseEvent) =>
            Utils.run_callback_on_click_outside_ref(e, ref, () => setShowMenu(false)),
        [ref]
    );

    useEffect(() => {
        showMenu
            ? document.addEventListener("mousedown", handleClickOutside)
            : document.removeEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, handleClickOutside, showMenu]);

    const handleClick = (callback?: Function) => {
        callback && callback()
        setShowMenu((prev) => !prev);
    }

    const linkClassName = "tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-lightblue tw-w-full tw-text-left"

    return (
        <div ref={ref} className="tw-relative tw-inline-block tw-z-50">
            <button className={`${showMenu ? "tw-bg-[#EBECF0]" : ""} hover:tw-bg-[#EBECF0] tw-rounded-[4px]  tw-text-sm tw-font-normal tw-text-[#172B4D] tw-p-2`} onClick={() => handleClick()}>Actions</button>
            {showMenu ? (
                <div className={`tw-origin-top-right tw-absolute tw-right-0 tw-w-48 tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                    <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <button type="button" disabled={disabled} onClick={() => { handleClick(onOpenImportModal) }} className={`${linkClassName} ${disabled ? 'tw-opacity-50' : ''}`} role="menuitem">Import from Excel</button>
                        <button type="button" disabled={disabled} onClick={() => { handleClick(openAttributeMenu) }} className={`${linkClassName} ${disabled ? 'tw-opacity-50' : ''}`} role="menuitem">Import from Attribute</button>
                        <button type="button" onClick={() => { handleClick(onOpenValidateModal) }} className={linkClassName} role="menuitem">Validate Excel</button>
                        <button type="button" onClick={() => handleClick(onExport)} className={linkClassName} role="menuitem">Download</button>
                    </div>
                </div>
            ) : null}
            <iframe
                style={{ display: "none" }}
                src={downloadUrl}
                id="iframe_pdw_download"
                title="pdw_download_create"
            />
        </div>
    )
}
